<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-globe mr-2"></i>{{Core.Definition.getDefinition('Général')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormGeneral"
                        getRoot="/setting/commerce-general"
                        saveRoot="/setting/commerce-general"
                        :formStructure="dataFormStructures.general">
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-tag mr-2"></i>{{Core.Definition.getDefinition('Produit')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormProduct"
                        getRoot="/setting/commerce-product"
                        saveRoot="/setting/commerce-product"
                        @onRequestSuccess="onRequestSuccessProduct"
                        :formStructure="dataFormStructures.product">
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-dollar mr-2"></i>{{Core.Definition.getDefinition('Taxes')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormTaxes"
                        @onRequestSuccess="onRequestSuccessTaxes"
                        @onSave="onSaveTaxes"
                        getRoot="/setting/commerce-taxes"
                        saveRoot="/setting/commerce-taxes"
                        :formStructure="dataFormStructures.taxes">
                    <slot slot="taxes">
                        <table class="mt-3 table table-striped">
                            <thead>
                            <tr>
                                <th>{{Core.Definition.getDefinition('Pays')}}</th>
                                <th>{{Core.Definition.getDefinition('Province')}}</th>
                                <th>{{Core.Definition.getDefinition('Libellé')}}</th>
                                <th>{{Core.Definition.getDefinition('Taux %')}}</th>
                                <th width="30px"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="tax, taxIndex in dataTaxes">
                                <td>
                                    <InputText
                                            v-model="tax.country"></InputText>
                                </td>
                                <td>
                                    <InputText
                                            v-model="tax.province"></InputText>
                                </td>
                                <td><InputText
                                        v-model="tax.label"></InputText></td>
                                <td>
                                    <InputText
                                        v-model="tax.rate"></InputText>
                                </td>
                                <td>
                                    <b-button @click="onTrashTaxClick(taxIndex)" class="btn btn-sm btn-danger"><i class="fa fa-trash-o"></i></b-button>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="5">
                                    <b-link @click="onAddTaxClick"  href="#" class="card-header-action btn-setting">
                                        <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Ajouter')}}
                                    </b-link>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </slot>
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-file-text mr-2"></i>{{Core.Definition.getDefinition('Termes et conditions')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormTerms"
                        getRoot="/setting/commerce-refund-policy"
                        saveRoot="/setting/commerce-refund-policy"
                        :formStructure="dataFormStructures.terms">
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-cog mr-2"></i>{{Core.Definition.getDefinition('Passerelle de paiement')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormPG"
                        getRoot="/setting/commerce-pg"
                        saveRoot="/setting/commerce-pg"
                        :formStructure="dataFormStructures.paymentGateway">
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-file-o mr-2"></i>{{Core.Definition.getDefinition('Apparence facture')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormInvoicing"
                        getRoot="/setting/commerce-invoicing"
                        saveRoot="/setting/commerce-invoicing"
                        :formStructure="dataFormStructures.invoicing">
                    <slot slot="invoicePreview">
                        <div class="text-right mb-3">
                            <b-button @click="onInvoicePreviewClick" class="btn btn-light btn-sm">
                                {{Core.Definition.getDefinition('Actualiser')}}
                            </b-button>
                        </div>
                        <Request
                                ref="requestInvoicePreview"
                                method="POST"
                                root="/setting/commerce-invoicing-preview"
                                :onRequestSuccess="onRequestSuccessInvoicePreview">
                            <slot slot="body">
                                <div v-html="dataInvoicePreview"></div>
                            </slot>
                        </Request>
                    </slot>
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-files-o mr-2"></i>{{Core.Definition.getDefinition('Apparence contrat')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormContract"
                        getRoot="/setting/contract-ui"
                        saveRoot="/setting/contract-ui"
                        :formStructure="dataFormStructures.contract">
                    <slot slot="contractPreview">
                        <div class="text-right mb-3">
                            <b-button @click="onContractPreviewClick" class="btn btn-light btn-sm">
                                {{Core.Definition.getDefinition('Actualiser')}}
                            </b-button>
                        </div>
                        <Request
                                ref="requestContractPreview"
                                method="POST"
                                root="/setting/contract-preview"
                                :onRequestSuccess="onRequestSuccessContractPreview">
                            <slot slot="body">
                                <div v-html="dataContractPreview"></div>
                            </slot>
                        </Request>
                    </slot>
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    import nav from '../../_nav'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    import Request from '../../../components/Request'
    import InputText from '../../../components/InputText'
    import InputNumber from '../../../components/InputNumber'
    export default {
        name: 'SettingsCommerce',
        components: {
            DynamicForm,
            Request,
            InputText,
            InputNumber
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataTaxes: [],
                dataInvoicePreview: '',
                dataContractPreview: '',
                dataFormStructures: {
                    taxes: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                key: 'taxes'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                        ]
                    },
                    general: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Format'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'currency'
                                                                    }
                                                                ]
                                                            },
                                                            {

                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Méthode de paiement autorisé'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'paymentMethodPublic'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'paymentMethodAdmin'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'currency',
                                type: 'select',
                                label: Core.Definition.getDefinition('Devise'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'paymentMethodPublic',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Public'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'paymentMethodAdmin',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Administration'),
                                value: null,
                                onSelect: function() {}
                            }
                        ]
                    },
                    product: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Abonnement récurrent'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'setWaitingOnAutoPaymentFail'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'autoSyncProfileCC'
                                                                    },
                                                                    {
                                                                        id: 'syncProfileCC'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Options avancés'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'autoBookingIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'conditionalIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Mode participant'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'ticketIsEnabled'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'teamIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'participantCategoryIsEnabled'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'tshirtIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'participantNameIsEnabled'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'participantBirthdateIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'participantUrgentContactIsEnabled'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    },
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'setWaitingOnAutoPaymentFail',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Mettre l\'état de l\'abonnement en attente si un paiement automatique n\'est pas complété.'),
                                description: Core.Definition.getDefinition('Le client ne pourra plus effectuer de réservation jusqu\'à ce que l\'état soit activée. L\'état sera activé si la prochaine tentative de paiement est réussie.'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'autoSyncProfileCC',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Association automatique des cartes de crédit aux abonnements récurrents'),
                                description: Core.Definition.getDefinition('De façon automatique, si un abonnement ne possède aucune carte de crédit associée, le système associe la carte de crédit du profil client à l\'abonnement.'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'syncProfileCC',
                                type: 'requestButton',
                                label: Core.Definition.getDefinition('Association manuelle'),
                                root:'/setting/commerce-subscription-sync-cc',
                                method:'GET',
                                onRequestSuccess: function() {

                                },
                                onRequestError: function() {

                                }
                            },
                            {
                                id: 'ticketIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion de la billetterie'),
                                description: Core.Definition.getDefinition('Un billet est généré à l\'achat du produit.'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'participantCategoryIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des catégories'),
                                description: Core.Definition.getDefinition('Les usagers pourront sélectionner une catégorie de participation lors de l\'achat du produit'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'tshirtIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des T-shirts'),
                                description: Core.Definition.getDefinition('Les usagers pourront sélectionner une taille de T-shirt lors de l\'achat du produit.'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'teamIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des équipes'),
                                description: Core.Definition.getDefinition('Les usagers pourront sélectionner ou créer une équipe lors de l\'achat du produit.'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'autoBookingIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des réservations automatiques'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'conditionalIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des conditionnelles'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'participantNameIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Participant: Nom et prénom'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'participantBirthdateIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Participant: Date de naissance'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'participantUrgentContactIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Participant: Contact d\'urgence'),
                                value: false,
                                onChange: function() {}
                            }
                        ]
                    },
                    terms: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'refundPolicy'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'refundPolicy',
                                type: Core.Value.typeEditor,
                                label: Core.Definition.getDefinition('Le client devra accepter cette politique avant l\'achat'),
                                value: ''
                            }
                        ]
                    },
                    paymentGateway: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'subMerchantId'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'passCode'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'subMerchantId',
                                type: 'text',
                                label: Core.Definition.getDefinition('Numéro Marchand'),
                                value: ''
                            },
                            {
                                id: 'passCode',
                                type: 'text',
                                label: Core.Definition.getDefinition('API Passcode'),
                                value: '',
                                description: 'Pour les comptes Bambora, les API PassCode dans Order Settings et Payment Profile doivent être identique.'
                            }
                        ]
                    },
                    invoicing: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Apparence'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logo'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'primaryColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoWidth'
                                                                    }
                                                                ]
                                                            },
                                                            {

                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'prefixNumber'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'nextNumber'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'generalNote'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'footerTxt'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayProductDescription'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displaySubscriptionBookingLimit'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displaySubscriptionPeriod'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                key: 'invoicePreview',
                                                caption: Core.Definition.getDefinition('Prévisualiser')
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'prefixNumber',
                                type: 'text',
                                label: Core.Definition.getDefinition('Préfix du numéro de facture'),
                                value: ''
                            },
                            {
                                id: 'nextNumber',
                                type: 'number',
                                label: Core.Definition.getDefinition('Prochain numéro de facture'),
                                value: 1
                            },
                            {
                                id: 'primaryColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur primaire'),
                                value: {}
                            },
                            {
                                id: 'logo',
                                type: 'avatar',
                                label: Core.Definition.getDefinition('Logo'),
                                value: '',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                }
                            },
                            {
                                id: 'logoWidth',
                                type: 'text',
                                label: Core.Definition.getDefinition('Largeur du logo'),
                                description: Core.Definition.getDefinition('EX: 100px ou 40%'),
                                value: ''
                            },
                            {
                                id: 'generalNote',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Note générale'),
                                value: ''
                            },
                            {
                                id: 'footerTxt',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Pied de page'),
                                value: ''
                            },
                            {
                                id: 'displayProductDescription',
                                type: Core.Value.typeSelect,
                                label: Core.Definition.getDefinition('Description du produit affichée'),
                                value: null,
                                onSelect() {}
                            },
                            {
                                id: 'displaySubscriptionBookingLimit',
                                type: Core.Value.typeCheckbox,
                                labelCols: 10,
                                label: Core.Definition.getDefinition('Si produit limité, affiche le nombre de réservation initiale'),
                                value: true,
                                onChange() {}
                            },
                            {
                                id: 'displaySubscriptionPeriod',
                                type: Core.Value.typeCheckbox,
                                labelCols: 10,
                                label: Core.Definition.getDefinition('Si produit récurrent ou produit limité, affiche la date de début et la date de fin de l\'abonnement'),
                                value: true,
                                onChange() {}
                            },
                            {
                                id: 'displaySubscriptionAutoPayments',
                                type: Core.Value.typeCheckbox,
                                labelCols: 10,
                                label: Core.Definition.getDefinition('Si produit récurrent, affiche la liste des auto-paiements'),
                                value: true,
                                onChange() {}
                            }
                        ]
                    },
                    contract: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Apparence'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoContract'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'primaryColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                      cols: [
                                                          {
                                                              fields: [
                                                                  {
                                                                      id: 'logoWidth'
                                                                  }
                                                              ]
                                                          },
                                                          {

                                                          }
                                                      ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'prefixNumber'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'nextNumber'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'generalNote'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'footerTxt'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                key: 'contractPreview',
                                                caption: Core.Definition.getDefinition('Prévisualiser')
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'prefixNumber',
                                type: 'text',
                                label: Core.Definition.getDefinition('Préfix du numéro de contrat'),
                                value: ''
                            },
                            {
                                id: 'nextNumber',
                                type: 'number',
                                label: Core.Definition.getDefinition('Prochain numéro de contrat'),
                                value: 1
                            },
                            {
                                id: 'primaryColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur primaire'),
                                value: {}
                            },
                            {
                                id: 'logoContract',
                                type: 'avatar',
                                label: Core.Definition.getDefinition('Logo'),
                                value: '',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                }
                            },
                            {
                                id: 'logoWidth',
                                type: 'text',
                                label: Core.Definition.getDefinition('Largeur du logo'),
                                description: Core.Definition.getDefinition('EX: 100px ou 40%'),
                                value: ''
                            },
                            {
                                id: 'generalNote',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Note générale'),
                                value: ''
                            },
                            {
                                id: 'footerTxt',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Pied de page'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        computed: {
        },
        methods: {
            onRequestSuccessProduct(data) {
                if (data.ticketIsEnabled !== undefined) {
                    Core.Session.Setting.setSetting('commerce.product.ticketIsEnabled',data.ticketIsEnabled)
                }
                if (data.teamIsEnabled !== undefined) {
                    Core.Session.Setting.setSetting('commerce.product.teamIsEnabled',data.teamIsEnabled)
                }
                if (data.tshirtIsEnabled !== undefined) {
                    Core.Session.Setting.setSetting('commerce.product.tshirtIsEnabled',data.tshirtIsEnabled)
                }
                if (data.participantCategoryIsEnabled !== undefined) {
                    Core.Session.Setting.setSetting('commerce.product.participantCategoryIsEnabled',data.participantCategoryIsEnabled)
                }
                this.$refs.dynamicFormProduct.$parent.$parent.$parent.$parent.$parent.navItems = []
                this.$refs.dynamicFormProduct.$parent.$parent.$parent.$parent.$parent.navItems = nav.getNav()
            },
            onRequestSuccessTaxes(data){
                if (data.taxes !== undefined) {
                    this.dataTaxes = Core.Value.encode(data.taxes, Core.Value.typeJSON)
                }
            },
            onSaveTaxes(){
                this.$refs.dynamicFormTaxes.addSaveArg('taxes',this.dataTaxes, Core.Value.typeJSON)
            },
            onAddTaxClick() {
                this.dataTaxes.push({
                    country: '',
                    province: '',
                    rate: '',
                    label: ''
                })
            },
            onTrashTaxClick(index) {
                this.dataTaxes.splice(index, 1)
            },
            onInvoicePreviewClick() {
                let form = this.$refs.dynamicFormInvoicing.$refs.form.form
                this.$refs.requestInvoicePreview.addArg('primaryColor', form.primaryColor, Core.Value.typeColor)
                this.$refs.requestInvoicePreview.addArg('generalNote', form.generalNote, Core.Value.typeLongText)
                this.$refs.requestInvoicePreview.addArg('footerTxt', form.footerTxt, Core.Value.typeText)
                this.$refs.requestInvoicePreview.addArg('prefixNumber', form.prefixNumber, Core.Value.typeText)
                this.$refs.requestInvoicePreview.addArg('nextNumber', form.nextNumber, Core.Value.typeText)
                this.$refs.requestInvoicePreview.addArg('logo', form.logo, Core.Value.typeAvatar)
                this.$refs.requestInvoicePreview.addArg('logoWidth', form.logoWidth, Core.Value.typeText)
                this.$refs.requestInvoicePreview.addArg('displayProductTitle', form.displayProductTitle, Core.Value.typeCheckbox)
                this.$refs.requestInvoicePreview.addArg('displayProductDescription', form.displayProductDescription, Core.Value.typeSelect)
                this.$refs.requestInvoicePreview.addArg('displaySubscriptionBookingLimit', form.displaySubscriptionBookingLimit, Core.Value.typeCheckbox)
                this.$refs.requestInvoicePreview.addArg('displaySubscriptionPeriod', form.displaySubscriptionPeriod, Core.Value.typeCheckbox)
                this.$refs.requestInvoicePreview.addArg('displaySubscriptionAutoPayments', form.displaySubscriptionAutoPayments, Core.Value.typeCheckbox)
                this.$refs.requestInvoicePreview.request()
            },
            onRequestSuccessInvoicePreview(data){
                if (data.invoicePreview !== undefined) {
                    this.dataInvoicePreview = data.invoicePreview
                }
            },
            onContractPreviewClick() {
                let form = this.$refs.dynamicFormContract.$refs.form.form
                this.$refs.requestContractPreview.addArg('primaryColor', form.primaryColor, Core.Value.typeColor)
                this.$refs.requestContractPreview.addArg('generalNote', form.generalNote, Core.Value.typeLongText)
                this.$refs.requestContractPreview.addArg('footerTxt', form.footerTxt, Core.Value.typeText)
                this.$refs.requestContractPreview.addArg('prefixNumber', form.prefixNumber, Core.Value.typeText)
                this.$refs.requestContractPreview.addArg('nextNumber', form.nextNumber, Core.Value.typeText)
                this.$refs.requestContractPreview.addArg('logo', form.logo, Core.Value.typeAvatar)
                this.$refs.requestContractPreview.addArg('logoWidth', form.logoWidth, Core.Value.typeText)
                this.$refs.requestContractPreview.request()
            },
            onRequestSuccessContractPreview(data){
                if (data.contractPreview !== undefined) {
                    this.dataContractPreview = data.contractPreview
                }
            }
        }
    }
</script>
